"use strict";

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.symbol");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = CodeBlock;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _copyToClipboard = _interopRequireDefault(require("copy-to-clipboard"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _highlight = _interopRequireDefault(require("highlight.js/lib/highlight"));

var _javascript = _interopRequireDefault(require("highlight.js/lib/languages/javascript"));

var _json = _interopRequireDefault(require("highlight.js/lib/languages/json"));

var _elixir = _interopRequireDefault(require("highlight.js/lib/languages/elixir"));

var _java = _interopRequireDefault(require("highlight.js/lib/languages/java"));

var _swift = _interopRequireDefault(require("highlight.js/lib/languages/swift"));

var _objectivec = _interopRequireDefault(require("highlight.js/lib/languages/objectivec"));

var _kotlin = _interopRequireDefault(require("highlight.js/lib/languages/kotlin"));

var _protobuf = _interopRequireDefault(require("highlight.js/lib/languages/protobuf"));

var _python = _interopRequireDefault(require("highlight.js/lib/languages/python"));

var _yaml = _interopRequireDefault(require("highlight.js/lib/languages/yaml"));

var _shell = _interopRequireDefault(require("highlight.js/lib/languages/shell"));

var _diff = _interopRequireDefault(require("highlight.js/lib/languages/diff"));

var _plaintext = _interopRequireDefault(require("highlight.js/lib/languages/plaintext"));

require("highlight.js/styles/atom-one-dark.css");

var _Icon = _interopRequireDefault(require("../Icon"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

_highlight["default"].registerLanguage('javascript', _javascript["default"]);

_highlight["default"].registerLanguage('js', _javascript["default"]);

_highlight["default"].registerLanguage('json', _json["default"]);

_highlight["default"].registerLanguage('elixir', _elixir["default"]);

_highlight["default"].registerLanguage('java', _java["default"]);

_highlight["default"].registerLanguage('kotlin', _kotlin["default"]);

_highlight["default"].registerLanguage('kt', _kotlin["default"]);

_highlight["default"].registerLanguage('protobuf', _protobuf["default"]);

_highlight["default"].registerLanguage('protobuffer', _protobuf["default"]);

_highlight["default"].registerLanguage('python', _python["default"]);

_highlight["default"].registerLanguage('py', _python["default"]);

_highlight["default"].registerLanguage('yaml', _yaml["default"]);

_highlight["default"].registerLanguage('yml', _yaml["default"]);

_highlight["default"].registerLanguage('shell', _shell["default"]);

_highlight["default"].registerLanguage('sh', _shell["default"]);

_highlight["default"].registerLanguage('plaintext', _plaintext["default"]);

_highlight["default"].registerLanguage('text', _plaintext["default"]);

_highlight["default"].registerLanguage('patch', _diff["default"]);

_highlight["default"].registerLanguage('diff', _diff["default"]);

_highlight["default"].registerLanguage('swift', _swift["default"]);

_highlight["default"].registerLanguage('objectivec', _objectivec["default"]);

_highlight["default"].registerLanguage('oc', _objectivec["default"]); // eslint-disable-next-line object-curly-newline


function CodeBlock(_ref) {
  var code = _ref.code,
      language = _ref.language,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["code", "language", "children"]);

  var source = code || children;

  var onCopy = function onCopy() {
    (0, _copyToClipboard["default"])(source);
  };

  return _react["default"].createElement(Pre, rest, _react["default"].createElement("code", {
    className: "hljs ".concat(language),
    dangerouslySetInnerHTML: {
      __html: _highlight["default"].highlightAuto(source, [language]).value
    }
  }), _react["default"].createElement(_IconButton["default"], {
    className: "copy-button",
    onClick: onCopy,
    tabIndex: "-1",
    color: "primary"
  }, _react["default"].createElement(_Icon["default"], {
    name: "copy",
    size: 16,
    style: {
      color: '#fff'
    }
  })));
}

CodeBlock.propTypes = {
  code: _propTypes["default"].string,
  language: _propTypes["default"].string,
  children: _propTypes["default"].any
};
CodeBlock.defaultProps = {
  code: '',
  language: 'text',
  children: null
};
var fontFamily = 'source-code-pro, Menlo, Monaco, Consolas, Courier New, monospace !important';

var Pre = _styledComponents["default"].pre.withConfig({
  displayName: "CodeBlock__Pre",
  componentId: "sc-1bpapaq-0"
})(["overflow:scroll;max-height:46.25rem;font-family:", ";display:block;font-size:14px;line-height:1.42857143;margin:0 0 32px;word-break:break-word;word-wrap:break-word;text-align:left;border-radius:5px;border:1px solid #dedede;background:#222;color:#fff;position:relative;.copy-button{display:none;position:absolute;top:8px;right:8px;}&:hover{.copy-button{display:block;}}code{counter-reset:line;counter-increment:line;padding:16px;font-family:", ";color:#fff;*{font-family:", ";}}"], fontFamily, fontFamily, fontFamily);